module.exports = __webpack_public_path__ + "media/images/mapping-process-4f6005b7.png";